<template>
    <div>
        <div class="page-pop" v-show="registerPop" @click="registerPopClose()" @touchmove.prevent @mousewheel.prevent></div>
        <div class="page-pop-content" v-show="registerPop">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
            <div class="close" @click="registerPopClose()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
            <div class="text">您未登录<br>登录后有助于您使用更多功能</div>
            <div class="button" @click="goRegister()">去登录</div>
        </div>
    </div>
</template>

<script>
import { goSignup } from '@/utils/tool'
export default {
    props:{
         registerPop: {
            default:false
        },
    },
    methods:{
        // goRegister(){
        //     this.$emit('goRegister')
        // },
        registerPopClose(){
            this.$emit('registerPopClose')
        },
        goRegister(){
            this.$maima.exhibition_page_register_click();
            if(this.$route.path.indexOf('/agenda') != -1){
                this.$store.commit('setAgendaRegTrigger');
            }else{
                goSignup('online', this.$route.query.shareKey, true, 1);
            }
        },
    }
}
</script>

<style scoped lang="scss">
*{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
.page-pop{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    cursor: pointer;
    width: 100vw;height: 100vh;
    background: rgba($color: #000000, $alpha: 0.65);
}
.page-pop-content{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1001;
    width: pxToVw(550);
    height: pxToVw(285);
    padding-top: pxToVw(76);
    background: #FFFFFF;
    border-radius: pxToVw(9);
    transform: translate(-50%,-50%);
    .close{
        position: absolute;
        right: 0;top: 0;
        width: pxToVw(67);
        height: pxToVw(67);
        padding: pxToVw(24);
        cursor: pointer;
        img{
            vertical-align: top;
            width: pxToVw(19);
            height: pxToVw(19);
        }
    }
    .text{
        width: 100%;
        height: pxToVw(72);
        margin: 0 auto pxToVw(17);
        font-size: pxToVw(19);
        text-align: center;
        color: #666666;
        line-height: pxToVw(32);
    }
    .button{
        width: pxToVw(200);
        margin: 0 auto;
        height: pxToVw(53);
        background: #C50819;
        border-radius: pxToVw(6);
        font-size: pxToVw(19);
        text-align: center;
        color: #FFF;
        cursor: pointer;
        line-height: pxToVw(53);
    }
}
@media screen and (max-width:767px) {
    .page-pop{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        cursor: pointer;
        width: 100vw;height: 100vh;
        background: rgba($color: #000000, $alpha: 0.65);
    }
    .page-pop-content{
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 1001;
        width: 82.4vw;
        height: 43.1vw;
        padding-top: 10.1vw;
        background: #FFFFFF;
        border-radius: 1.1vw;
        transform: translate(-50%,-50%);
        .close{
            position: absolute;
            right: 3.6vw;top: 2.8vw;
            width: 2.8vw;
            height: 2.7vw;
            // padding: pxToVw(24);
            cursor: pointer;
            img{
                vertical-align: top;
                width: 2.8vw;
                height: 2.7vw;
            }
        }
        .text{
            width: 100%;
            height: 10.8vw;
            margin: 0 auto 2.8vw;
            font-size: 3.2vw;
            text-align: center;
            color: #666666;
            line-height: 4.8vw;
        }
        .button{
            width: 30.1vw;
            margin: 0 auto;
            height: 8vw;
            background: #C50819;
            border-radius: 0.6vw;
            font-size: 3.2vw;
            text-align: center;
            color: #FFF;
            cursor: pointer;
            line-height: 8vw;
        }
    }
}
</style>